import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { RiskRuleEditor } from '@/components/shared/RiskRuleEditor';

export const Route = createFileRoute(
  '/(client)/risk/(pages)/(edit)/rules/$id/edit/',
)({
  component: RuleEditPage,
});

function RuleEditPage() {
  const { id } = Route.useParams();
  const navigate = useNavigate();

  return (
    <RiskRuleEditor
      id={id}
      onLeaveNotEditable={() =>
        void navigate({ to: '/risk/rules/$id', params: { id } })
      }
      onCloned={() => void navigate({ to: '/risk/rules' })}
    />
  );
}
